var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper text-center py-5"},[_c('div',{staticClass:"spinner-wrapper w-100"},[_c('b-spinner',{staticClass:"spinner",attrs:{"label":"Loading...","type":_vm.type,"variant":_vm.variant}})],1),_c('h1',{staticClass:"my-5"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }